module.exports = __webpack_public_path__ + "static/wtm-80a46807fe0cc812ab9f81af9bfde49e.png";